module.exports = __webpack_public_path__ + "media/img/frontend_application/reward-icon-d2363bde947b7d98822321c0081c437e.png";